import { useMutation } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast } from '@utils'
import { useLanguage } from '@context'
import type { AudioResult } from './useFtVoiceNote'

// « Dicter » in the note editor: the recording becomes text, added to the
// note being written. Nothing is saved by the API.
const transcribe = async (audioResult: AudioResult): Promise<string> => {
  const formData = new FormData()
  if (audioResult.blob) {
    // Web: append the Blob directly
    formData.append('audio', audioResult.blob, audioResult.name)
  } else {
    // Native: append using { uri, type, name } format
    formData.append('audio', {
      uri: audioResult.uri,
      type: audioResult.type,
      name: audioResult.name,
    } as unknown as Blob)
  }
  const { data } = await api.post<{ transcription: string }>('/ft_voice-transcribe', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data.transcription
}

export const useFtVoiceTranscribe = () => {
  const { t } = useLanguage()
  return useMutation<string, Error, AudioResult>({
    mutationFn: transcribe,
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}
